module.exports = require('./lib/_stream_duplex.js');



//////////////////
// WEBPACK FOOTER
// /app/~/stream-browserify/~/readable-stream/duplex-browser.js
// module id = 95
// module chunks = 0